export interface Validity {
  valid: boolean;
  error: string;
}

const getMinCharsPattern = (minChars: number): RegExp =>
  new RegExp(`^[\\p{Lu}\\p{Ll}a-zA-ZÀ-ž0-9\\-\\/]{${minChars},}$`, 'u');
const getMinLettersOrNumbersPattern = (minChars: number): RegExp =>
  new RegExp(`^[0-9a-zA-ZÀ-ž]{${minChars},}$`);
const getMinAlphaNumericSymbolPattern = (minChars: number): RegExp =>
  new RegExp(`^[ a-zA-ZÀ-ž0-9\\,.\\-'“:;/\`\\"]{${minChars},}$`);
const NIP_PATTERN =
  '^(([1-9]\\d[1-9][- ][1-9]{3}[- ][1-9]{2}[- ][1-9]{2})|([1-9]\\d[1-9][- ][1-9]{2}[- ][1-9]{2}[- ][1-9]{3}))|(\\d{10})$';
const IBAN_PATTERN = '^PL[ ]?[0-9]{2}(?:[ ]?[0-9]{4}){6}';
const PESEL_PATTERN = '\\d{11}';
const DOB_PATTERN = '^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$';
const ZIP_CODE_PATTERN = '^d{2}-d{3}$';
const LEGAL_NAME_PATTERN = '.{2,}';
const HOLDER_NAME_PATTERN = '.{2,}';
const CITY_PATTERN = '.{2,}';

const parseDate = (val: string) => {
  const [year, month, day] = val.split('-').map(d => parseInt(d, 10));
  return new Date(year, month - 1, day);
};

const isNotFutureDate = (val: string): Validity => {
  const date = parseDate(val);

  return date <= new Date()
    ? { valid: true, error: null }
    : {
      valid: false,
      error: 'dlv_dac7_birthDate_error_is_not_future',
    };
};

const isNotUnderAge = (val: string): Validity => {
  const date = parseDate(val);

  const timeDifference = Date.now() - new Date(date).getTime(); // in milliseconds

  /**
   * JavaScript Date objects represent a single moment in time in a platform-independent format.
   * Date objects contain a Number that represents milliseconds since 1 January 1970 UTC.
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#Syntax
   */
  const age = Math.abs(new Date(timeDifference).getUTCFullYear() - 1970);

  return age >= 18
    ? { valid: true, error: null }
    : {
      valid: false,
      error: 'dlv_dac7_birthDate_error_is_under_age',
    };
};

const isNotBefore1900 = (val: string): Validity => {
  const date = parseDate(val);

  return date.getFullYear() >= 1900
    ? { valid: true, error: null }
    : {
      valid: false,
      error: 'dlv_dac7_birthDate_error_is_invalid',
    };
};

const birthDateValidations = [isNotFutureDate, isNotUnderAge, isNotBefore1900];

export default {
  getMinCharsPattern,
  getMinLettersOrNumbersPattern,
  getMinAlphaNumericSymbolPattern,
  NIP_PATTERN,
  IBAN_PATTERN,
  PESEL_PATTERN,
  DOB_PATTERN,
  ZIP_CODE_PATTERN,
  LEGAL_NAME_PATTERN,
  HOLDER_NAME_PATTERN,
  CITY_PATTERN,
  birthDateValidations,
};
